import React from "react"
import PropTypes from "prop-types"
import cn from "classnames"

import styles from "./appbar-head.module.css"

export const AppbarHead = ({ children, bezel = true, ...props }) => {
  // filtering out style and className
  /* eslint-disable-next-line react/prop-types */
  const { style, className, ...rest } = props

  return (
    <div
      {...rest}
      className={cn(styles.AppbarHead, { [styles.bezelless]: !bezel })}
    >
      {children}
    </div>
  )
}

AppbarHead.displayName = "AppbarHead"

AppbarHead.propTypes = {
  /**
   * Container for the AppbarHead content.
   */
  children: PropTypes.node,
  /**
   * Adds padding.
   */
  bezel: PropTypes.bool,
}

AppbarHead.defaultProps = {
  bezel: true,
}
